import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const setAdminCode = (code) => {
  if (code) {
    localStorage.setItem("cakesbyky_admin_code", code);
  } else {
    localStorage.removeItem("cakesbyky_admin_code");
  }
};

export const getAdminCode = () => localStorage.getItem("cakesbyky_admin_code") || "";

// Attach admin code header when present
api.interceptors.request.use((config) => {
  const code = getAdminCode();
  if (code) config.headers["X-Admin-Code"] = code;
  return config;
});
